
import wmConfig												from "../data/wmConfig";
import ToolTurbine											from "../classes/ToolTurbine";
import ToolSensor											from "../classes/ToolSensor";
import {ToolCable, ToolCableAdd}							from "../classes/ToolCable";
import {ToolRoad, ToolRoadAdd}								from "../classes/ToolRoad";
import ToolGate												from "../classes/ToolGate";
import ToolAnnotation										from "../classes/ToolAnnotation";
import {ToolMeasure}										from "../classes/ToolMeasure";
import {ToolBoundary}										from "../classes/ToolBoundary";
import {ToolDrawing}										from "../classes/ToolDrawing";
import {ToolHistory}										from "../classes/ToolHistory";
import ToolSubstation										from "../classes/ToolSubstation";
import atlasApi												from "../utils/atlasapi";
import {ToolExclusion, ToolExclusionPolygon}				from "../classes/ToolExclusion";
import {ToolAutoRoad}										from "../classes/ToolAutoroad";
import drawTheme											from "../utils/drawUtilsTheme";
import log													from "../utils/log";
import {
	processOwnersAndLands,
	updateGeoJsonLayer
}															from "../utils/functions";
class turbineControl {
	
	handler = null;
	stylingPanels = [];
	
	constructor(map, draw, scenario, setScenario){
		this.map			= map;
		this.draw			= draw;
		this.draw.tc		= this;
		this.scenario		= scenario;
		this.setState		= setScenario;
		this.es				= this._escape.bind(this);
		this.clickedButton	= null;
	}
	setScenario(scenario){
		
		
		this.scenario = scenario;
		this.setState(scenario);
		if(scenario.scenario_id && !this.draw.context.versionid)
			this.map.controlBar.enable(['turbine_modeon', 'turbine_add', 'add_circle', 'turbine_remove', 'add_boundary', 'cable_modeon','electrical_modeon','add_cable', 'road_mode', 'road_modeon', 'add_road', 'sensor_modeon', 'annotation_modeon', 'boundary_modeon', 'exclusion_mode', 'drawing_mode', 'exclude_polygon_add', 'changelog']);
		else {
			this.map.controlBar.disable();
		}
		this.map.controlBar.enable(['add_circle', 'landowner_mode', 'measure_modeon']);
		

		if(this.handler && this.handler.update)
			this.handler.update();
		if(this.handler && this.handler.display)
			this.handler.display();
		
		if(!this.record){
			this.record = new log(this);
		}
		this.record.getHistory();
	}
	init(){
		
		//clear other button event handlers
		this.clickedButton.classList.add('active');
		this.exitOthers();
		if(this.draw?.context?.getters?.workMode?.label != 'Project' && this.changeWorkMode)
			this.changeWorkMode('default', this.draw.context.getters.project);

		if(turbineControl.resetFn){
			clearTimeout(turbineControl.resetFn);
			turbineControl.resetFn = null;
		}		
		if(this.handler && this.handler.init)
			this.handler.init();
		
		document.addEventListener('keyup', this.es);
		this.map.disableEvents = 1;
		var self = this;
	}
	secondaryInit(){
		
		//clear other button event handlers
		this.secondaryButton?.classList?.add('active');
		this.exitOthers();
	
		if(this.secondaryHandler && this.secondaryHandler.init)
			this.secondaryHandler.init();
		
		document.addEventListener('keyup', this.es);
		this.map.disableEvents = 1;
	}
	_escape(e){
		if(e.keyCode === 27 /*escape*/) {
			if(this.secondaryHandler){
				
				this.exitSecondary();
				return;
			}
			this.exit();
		}
	}
	
	exit(){
		this.map.getContainer().classList.remove("cursor-add-turbine", "cursor-delete-turbine", "cursor-pen");
		this.clearEventHandlers();
		this.map.disableEvents = 0;
		this.draw.draw.changeMode('simple_select');
		
		if(this.handler && this.handler.exit){
			this.handler.exit();
			this.handler = null;
		}
		if(this.clickedButton && this.clickedButton.id){
			document.querySelectorAll("#"+this.clickedButton.id).forEach((e)=>{
				e.classList.remove('active');
			});
			this.clickedButton = null;
		}
		document?.activeElement.blur();
		if(!turbineControl.resetFn){
			turbineControl.resetFn = setTimeout(()=>{
				this.landownerModeForce();
			}, 50);
		}
		this.clearStylingPanels();
	}
	
	exitSecondary(){
		this.map.getContainer().classList.remove("cursor-measure", "cursor-delete-turbine", "cursor-pen");
		this.clearEventHandlers();
		
		this.draw.draw.changeMode('simple_select');
		
		if(this.secondaryHandler && this.secondaryHandler.exit){
			this.secondaryHandler.exit();
			this.secondaryHandler = null;
		}
		if(this.secondaryButton){
			
			document.querySelectorAll("#"+this.secondaryButton.id).forEach((e)=>{
				e.classList.remove('active');
			});
			this.secondaryButton = null;
		}
		document?.activeElement.blur();
	}
	clearEventHandlers(){
		this.map.off('click', this.ad);
		this.map.off('click', this.rm);
		document.removeEventListener('keyup', this.es);
	}
	
	addBoundary(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target;
		this.init();
		this.map.getContainer().classList.add("cursor-pen");
		this.clickedButton.classList.add('active');
		this.draw.draw.changeMode('boundary_mode', {onFinish:()=>{this.exit();}});
		//change to boundary mode
		
	}
	addCable(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolCableAdd(this);
		this.init();
		//change to boundary mode
		
	}
	cableMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolCable(this);
		this.init();
	}
	cableModeForce(){
		if(this.clickedButton && this.clickedButton.id == 'cable_modeon'){
			return;
		}
		document.querySelector("#cable_modeon").click();
	}
	modeForce(mode){
		if(this.clickedButton && this.clickedButton.id == mode){
			return;
		}
		document.querySelector("#"+mode).click();
	}
	
	annotationMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolAnnotation(this);
		this.init();
	}
	roadMode(e, view){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolRoad(this, view);
		this.init();
	}
	autoroadMode(e, view){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolAutoRoad(this);
		this.init();
	}
	
	boundaryMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolBoundary(this);
		this.init();
	}
	
	drawingMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolDrawing(this);
		this.init();
	}
	roadModeForce(){
		if(this.clickedButton && this.clickedButton.id == 'road_modeon'){
			return;
		}
		document.querySelector("#road_modeon").click();
	}
	
	historyMode(e){
		//this.exit();
		
		this.secondaryButton = e.target.closest("button");
		this.secondaryButton.classList.add('active');
		this.secondaryHandler = new ToolHistory(this);
		this.secondaryInit();
	}
	addRoad(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolRoad(this, true);
		this.init();
		//change to boundary mode
		
	}
	addProject(e){
		
		this.exit();
		this.clickedButton = e.target.closest("button");;
		this.init();
		this.map.getContainer().classList.add("cursor-pen");
		this.clickedButton.classList.add('active');
		this.draw.draw.changeMode('boundary_mode', {onFinish:()=>{this.exit();}});
		this.stackDrawLayers();
		//change to boundary mode
		
	}
	turbineMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolTurbine(this);
		this.init();
	}
	turbineModeForce(){
		document.querySelector("#turbine_modeon").click();
	}
	measureMode(e){
		e.stopPropagation();
		if(this.toggleSecondary(e))
			return;
		this.exitSecondary();
		this.secondaryButton = e.target.closest("button");
		this.secondaryButton.classList.add('active');
		this.secondaryHandler = new ToolMeasure(this);
		this.secondaryInit();
	}
	landownerMode(e){
		e.stopPropagation();
		this.exit();
		this.handler = null;
		if(this.workMode?.obj)
			this.workMode.obj.refresh(Math.random());
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
	}
	landownerModeForce(){
		document.querySelector("#landowner_mode")?.click();
	}
	updateTurbine(turbineid, coordinates){
		this.handler?.updateTurbine(turbineid, coordinates);
	}
	updateTurbineName(name, turbineid, refresh){
		this.handler?.updateTurbineName(name, turbineid, refresh);
	}

	sensorMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolSensor(this);
		this.init();
	}
	sensorModeForce(){
		
		if(this?.handler?.type != 'sensors')
			document.querySelector("#sensor_modeon").click();
	}
	gateMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolGate(this);
		this.init();
	}
	gateModeForce(){
		document.querySelector("#gatemodeon").click();
	}
	addSensor(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.handler = new ToolSensor(this, 1);
		this.init();
		this.map.getContainer().classList.add("cursor-add-sensor");
	}
	removeSensor(e){
		if(!this.scenario.scenario_id || this.toggle(e))
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.handler = new ToolSensor(this, 2);
		this.init();
		this.map.getContainer().classList.add("cursor-delete-sensor");
	}
	substationMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolSubstation(this);
		this.init();
	}
	substationModeForce(){
		document.querySelector("#substation_modeon").click();
	}
	addExclusionPolygon(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolExclusion(this, 'polygon');
		this.init();
		
	}
	addExclusionPoint(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolExclusion(this, 'point');
		this.init();
		
	}
	addExclusionExtract(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolExclusion(this, 'extract');
		this.init();
		
	}
	addExclusionUpload(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolExclusion(this, 'upload');
		this.init();
		
	}
	toggle(e){
		if(this.clickedButton && this.clickedButton.id == e.target.closest('button').id){ //if clicking the same button again exit function
			this.exit();
			return true;
		}
		return false;
	}
	toggleSecondary(e){
		if(this.secondaryButton && this.secondaryButton.id == e.target.closest('button').id){ //if clicking the same button again exit function
			this.exitSecondary();
			return true;
		}
		return false;
	}
	exitOthers(){
		const event = new KeyboardEvent("keyup",{
			'keyCode': 27
		});
		this.map.getContainer().dispatchEvent(event);
	}
	stackDrawLayers(){
		
		drawTheme.forEach((l)=>{
			if(this.map.getLayer(l.id+".cold"))
				this.map.moveLayer(l.id+".cold");
			if(this.map.getLayer(l.id+".hot"))
				this.map.moveLayer(l.id+".hot");
		});
		
	}
	
	refreshProperties(){
		atlasApi.getScenario(this.scenario.projectid, this.scenario.scenario_id, null, this.draw?.context?.getters?.workMode?.value).then((res)=>{

			if(res && res.scenario_id !== undefined){
				var owners = res.landowners;
				var geodata = res.properties;
				processOwnersAndLands(owners, geodata);
				this.draw?.context?.setters.setOwners(owners);
				this.draw?.context?.setters.setOwnersPersist?.(owners);
				updateGeoJsonLayer(this.map, geodata);
			}
		});
	}
	
	addStylingPanel(handler){
		const h = this.stylingPanels.findIndex((a)=>{return a.type == handler.type;});
		
		if(h>-1){
			return this.stylingPanels[h] = handler;
		}
		this.stylingPanels.push(handler);
	}
	
	clearStylingPanel(handler){
		
		const h = this.stylingPanels.findIndex((a)=>{return a.type == handler.type;});
		
		if(h>-1){
			this.stylingPanels[h].closeEditPanel();
			delete this.stylingPanels[h];
		}
	}
	clearStylingPanels(){
		
		this.stylingPanels.forEach((p)=>{
			p.closeEditPanel();
		});
		this.stylingPanels = [];
	}
	checkOutdated(res, refresh = true){
		
		if(!res)
			return;
		
		const aep = typeof res.outdatedAEP != 'undefined';
		const sensors = typeof res.outdatedSensors != 'undefined' && Array.isArray(res.outdatedSensors);
		const s = {...this.scenario};
		
		if(!aep && !sensors)
			return false;

		if(aep){
			s.outdatedAEP = res.outdatedAEP;
			s.aep.outdated = res.outdatedAEP;
			
			s.wtgs.forEach((t)=>{t.outdated=res.outdatedAEP;});
			
			
		}
		if(sensors){
			s.nsas.forEach((sensor)=>{
	
				const a = res.outdatedSensors.find(nsa => parseInt(nsa) == sensor.nsaid);
				if(a)
					sensor.outdated = true;
				else
					sensor.outdated = false;
				
			});
			s.outdatedSensors = !!res.outdatedSensors.length;
		}
		
		this.setScenario(s);
		
		if(aep || sensors){
			if(this.handler && refresh)
				this.handler.display();
		} 

	}
}
export default turbineControl;